import { COMMON, countryName } from "@/pages/admin/CountryPicker";
import { isApproved } from "@/pages/admin/SeasonalCalendar";

const DAYS = 30;
const todayUK = () => new Date().toLocaleDateString("en-CA", { timeZone: "Europe/London" });
const plus = (d, n) => { const x = new Date(`${d}T12:00:00Z`); x.setUTCDate(x.getUTCDate() + n); return x.toISOString().slice(0, 10); };
const covers = (t, cc, from, to) => t.starts_on <= to && t.ends_on >= from && (!t.countries?.length || t.countries.includes(cc));

function Chips({ list, testid, tone }) {
  return (
    <div className="flex flex-wrap gap-1.5 mt-2" data-testid={testid}>
      {list.map((c) => <span key={c} className={`text-xs font-semibold rounded-full px-2.5 py-1 ${tone}`}>{countryName(c)}</span>)}
    </div>
  );
}

// Which of the main countries have no seasonal theme in the next 30 days (worldwide themes count as cover).
export default function CoveragePanel({ rows }) {
  const from = todayUK();
  const to = plus(from, DAYS - 1);
  const all = rows || [];
  const none = COMMON.filter((cc) => !all.some((t) => covers(t, cc, from, to)));
  const draftOnly = COMMON.filter((cc) => !none.includes(cc) && !all.some((t) => isApproved(t) && covers(t, cc, from, to)));
  const fmt = (d) => new Date(`${d}T12:00:00Z`).toLocaleDateString("en-GB", { day: "numeric", month: "short" });
  return (
    <div className="card-recipe !p-5 mb-6" data-testid="seasonal-coverage">
      <p className="font-bold text-rf-ink">Country coverage · next {DAYS} days ({fmt(from)} – {fmt(to)})</p>
      {!none.length && !draftOnly.length ? (
        <p className="mt-2 text-sm text-emerald-700 font-semibold" data-testid="coverage-all-good">All {COMMON.length} main countries have an approved theme at some point in the next {DAYS} days.</p>
      ) : (
        <>
          {none.length > 0 && <><p className="mt-2 text-sm font-semibold text-red-700" data-testid="coverage-none-count">{none.length} of {COMMON.length} countries have no theme at all:</p>
            <Chips list={none} testid="coverage-none" tone="bg-red-50 text-red-800 border border-red-200" /></>}
          {draftOnly.length > 0 && <><p className="mt-3 text-sm font-semibold text-amber-700" data-testid="coverage-draft-count">{draftOnly.length} only have drafts; approve them so they show:</p>
            <Chips list={draftOnly} testid="coverage-draft-only" tone="bg-amber-50 text-amber-800 border border-amber-200" /></>}
        </>
      )}
      <p className="mt-3 text-xs text-rf-ink-soft">Worldwide themes count as cover for every country. Checks the {COMMON.length} one-tap countries in the country chooser.</p>
    </div>
  );
}
